import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEO from '@/components/base/SEO';
import { categories, categoryMap } from '@/mocks/categories';
import { getArticlesByCategory } from '@/mocks/articles';

export default function Category() {
  const { slug = 'football' } = useParams<{ slug: string }>();
  const category = categoryMap[slug];
  const articles = getArticlesByCategory(slug);

  const displayName = category ? category.name : '分类';
  const displayDesc = category ? category.description : '';

  const categoryLabels: Record<string, string> = {
    football: '足球',
    basketball: '篮球',
    tennis: '网球',
    esports: '电竞',
    others: '综合',
  };

  return (
    <>
      <ScrollToTop />
      <SEO
        title={`ky体育${displayName}赛事 - 官方体育竞技平台`}
        description={`ky体育${displayName}频道，${displayDesc}`}
        keywords={`ky体育,ky体育${displayName},${displayName}赛事,ky体育官网,ky体育平台`}
        canonicalUrl={`https://www.ky-sports.com/category/${slug}`}
      />
      <Navbar />
      <main className="bg-background-50">
        <div className="pt-20">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: displayName },
            ]}
          />

          <section className="w-full px-4 md:px-6 py-10">
            <div className="max-w-7xl mx-auto">
              <div className="mb-8">
                <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                  {displayName}赛事
                </h1>
                <p className="mt-2 text-sm text-foreground-500">{displayDesc}</p>
              </div>

              <div className="flex items-center gap-2 mb-10 overflow-x-auto pb-2 flex-wrap">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
                      slug === cat.slug
                        ? 'bg-primary-500 text-white'
                        : 'bg-background-100 text-foreground-600 hover:bg-background-200 border border-background-200'
                    }`}
                  >
                    <i className={`${cat.icon} text-sm`}></i>
                    {cat.name}
                  </Link>
                ))}
              </div>

              {articles.length > 0 ? (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {articles.map((article) => (
                    <Link
                      key={article.id}
                      to={`/article/${article.id}`}
                      className="group cursor-pointer"
                    >
                      <article className="bg-background-50 border border-background-200 rounded-xl overflow-hidden hover:border-primary-300 transition-all duration-300 h-full flex flex-col">
                        <div className="relative h-48 overflow-hidden">
                          <img
                            src={article.imageUrl}
                            alt={article.title}
                            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                          />
                          <span className="absolute top-3 left-3 bg-primary-500 text-white text-xs px-2.5 py-1 rounded-full">
                            {categoryLabels[article.category] || article.category}
                          </span>
                        </div>
                        <div className="p-5 flex flex-col flex-1">
                          <h3 className="font-semibold text-foreground-950 text-base leading-snug line-clamp-2 group-hover:text-primary-500 transition-colors">
                            {article.title}
                          </h3>
                          <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-2 flex-1">
                            {article.summary}
                          </p>
                          <div className="mt-4 pt-3 border-t border-background-200 flex items-center justify-between text-xs text-foreground-400">
                            <span>{article.date}</span>
                            <span className="flex items-center gap-1">
                              <i className="ri-eye-line"></i> {article.views.toLocaleString()}
                            </span>
                          </div>
                        </div>
                      </article>
                    </Link>
                  ))}
                </div>
              ) : (
                <div className="text-center py-20">
                  <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-background-100 flex items-center justify-center">
                    <i className="ri-inbox-line text-2xl text-foreground-400"></i>
                  </div>
                  <p className="text-foreground-500">该分类暂无文章</p>
                </div>
              )}
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}